import axios from "axios";
import { environment } from "../../environments/environment";

export interface ManagerProfileResponse {
  manager_id: string;
  full_name: string;
  manager_email: string;
  cpf?: string;
  date_of_birth?: string;
  gender?: string;
}

export interface UpdateManagerProfileData {
  full_name?: string;
  manager_email?: string;
  cpf?: string;
  date_of_birth?: string;
  gender?: string;
}

/**
 * Busca os dados do manager
 */
export const getManagerProfile = async (managerId: string): Promise<ManagerProfileResponse> => {
  const response = await axios.get<ManagerProfileResponse>(
    `${environment.apiUrl}/api/managers/${managerId}/`,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (response.status !== 200) {
    throw new Error('Erro ao buscar dados do manager');
  }

  return response.data;
};

/**
 * Atualiza os dados do manager
 */
export const updateManagerProfile = async (
  managerId: string,
  data: UpdateManagerProfileData
): Promise<ManagerProfileResponse> => {
  const response = await axios.patch<ManagerProfileResponse>(
    `${environment.apiUrl}/api/managers/${managerId}/`,
    data,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (response.status !== 200) {
    throw new Error('Erro ao atualizar dados do manager');
  }

  return response.data;
};


